import { MoneyInput } from '../../components/MoneyInput/MoneyInput';
import { fmtN } from '../../lib/format';
import { MONTH_SHORT } from '../../lib/dates';
import type { Account } from '@budgetx/shared';
import styles from './AccountMonthTable.module.css';

interface Props {
  year: number;
  monthIdx: number;
  accounts: Account[];
  onRename(id: number, name: string): void;
  onEditAmount(id: number, month: number, next: number | null): void;
  onDelete(id: number): void;
}

export function AccountMonthTable({
  year,
  monthIdx,
  accounts,
  onRename,
  onEditAmount,
  onDelete,
}: Props) {
  const totals: (number | null)[] = Array(12).fill(null);
  for (let m = 0; m < 12; m++) {
    let sum = 0;
    let any = false;
    for (const a of accounts) {
      const v = a.amounts[m];
      if (v !== null && v !== undefined) {
        sum += v;
        any = true;
      }
    }
    totals[m] = any ? sum : null;
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.head}>
        <h2 className={styles.title}>Saldo pr. måned · {year}</h2>
      </div>
      <div className={styles.scroll}>
        <div className={styles.inner}>
          <div className={styles.headRow}>
            <div className={styles.acctCol}>Konto</div>
            {MONTH_SHORT.map((m, i) => (
              <div
                key={m}
                className={`${styles.monthCell} ${i === monthIdx ? styles.monthCurrent : ''}`}
              >
                {m}
              </div>
            ))}
          </div>

          {accounts.map((a) => (
            <div key={a.id} className={styles.acctRow}>
              <div className={styles.nameCell}>
                <span className={styles.badge}>{a.badge}</span>
                <input
                  className={styles.nameInput}
                  value={a.name}
                  onChange={(e) => onRename(a.id, e.target.value)}
                  onFocus={(e) => e.target.select()}
                />
                <button
                  className={styles.deleteBtn}
                  title="Slet konto"
                  onClick={() => onDelete(a.id)}
                >
                  ×
                </button>
              </div>
              {MONTH_SHORT.map((_, m) => (
                <MoneyInput
                  key={m}
                  value={a.amounts[m] ?? null}
                  onCommit={(v) => onEditAmount(a.id, m, v)}
                  placeholder="—"
                />
              ))}
            </div>
          ))}

          <div className={styles.totalRow}>
            <div className={styles.totalLabel}>I alt</div>
            {totals.map((v, m) => (
              <div
                key={m}
                className={styles.totalCell}
                style={{ color: m === monthIdx ? 'var(--accent-dark)' : 'var(--text)' }}
              >
                {v === null ? '—' : fmtN(v)}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
